<template>
  <Panel :title="title">
    <Draggable handle=".handle .icon" @end="onDragEnd" class="draggable-list">
      <Content class="item" v-for="(item,index) in items" :key="item.id+'_'+index">
        <div class="handle"><Icon :icon="Icons.drag" cursor="move" /></div>
        <Part v-for="(field, fi) in fields" :key="fi" :flex="field.flex || field.primary?1:'auto'" :class="visibilityClass(field, item)" :width="field.width">
          <component :is="itemTag(field)" :class="itemClass(field, item)" :title="itemTitle(field, item)" :style="itemStyle(field, item)" :icon="itemIcon(field, item)">
            {{itemContent(field, item)}}
            <RowActions :actions="field.actions" :item="item" v-on="actionBinding(item, index)" />
          </component>
        </Part>
      </Content>
    </Draggable>
  </Panel>
</template>

<script>
import Icons from '@/lib/Icons';
import Badge from "@/components/ui/utils/Badge";
import Icon from "@/components/ui/utils/Icon";
import Content from "@/components/ui/layout/Content";
import Panel from "@/components/ui/layout/Panel";
import Draggable from "vuedraggable";
import Txt from "@/components/ui/utils/Txt";
import FormattedList from "@/mixins/FormattedList";
import Part from "@/components/ui/layout/Part";
import RowActions from "@/components/ui/lists/RowActions";

export default {
  name: "DraggableList",
  mixins: [FormattedList],
  components: {RowActions, Part, Txt, Panel, Content, Icon, Badge, Draggable},
  props : {
    title : String,
  },
  data() {
    return {
      Icons,
    }
  },

  methods : {
    onDragEnd(data) {
      this.$emit('sort', data.oldIndex, data.newIndex)
    }
  }

}
</script>
